export enum ModalCloseReason {
	close = "close",
	cancel = "cancel",
	escape = "escape"
}
